<template>
    <div class="p-3" style="min-height: 130vh; background-size: cover; background-attachment: fixed; overflow-y: scroll; background: #fff;">
        <div class="row align-items-center pl-4 pb-3 mt-2">
            <div class="mx-auto">
                <h2
                    class="mb-0 w-100"
                    style="color: #890503"
                >
                    Holiday List
                </h2>
            </div>
        </div>

        <!-- <table class="col-12">
            <thead>
                <tr>
                    <th class="text-white">Date</th>
                    <th class="text-white">Name</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(close, index) in closedDayList" :key="index">
                    <td>{{close.date}}</td>
                    <td>{{close.name}}</td>
                </tr>
            </tbody>
        </table> -->

        <div class="text-center py-3 my-2" style="border: 2px solid #890503; border-radius: 7px;" v-for="(close, index) in closedDayList" :key="index">
            <div style="color: #890503; font-weight: 600">{{close.date}}</div>
            <div style="color: #890503;">{{close.name}}</div>
        </div>


    </div>
</template>
<script>
export default {
  data() {
    return {
      closedDayList: []
    };
  },
  methods: {
    async closedDays(date) {
        try {
        const res = await axios.get('https://api.2dboss.com/api/lv/holiday_list');
        // console.log(res.data.data)
        this.closedDayList = res.data.data;
        } catch (error) {
        console.log(error);
        }
    },
  },
  mounted() {
    this.closedDays();
  },
};
</script>
<style scoped>

table {
        width: 100%;
        border-collapse: collapse;
        border-radius: 5px;
        overflow: hidden;
        box-shadow: 0 0 20px rgba(0,0,0,0.1);
    }

    th,
    td {
        padding: 10px !important;
        background-color: rgba(255,255,255,0.2);
        color: #fff;
    }

    th {
        text-align: left;
    }

    thead {
        th {
            background: #242946;
            color: black;
        }
    }

    tbody {
        tr {
            &:hover {
                background-color: rgba(95, 111, 180, 0.3);
            }
        }
        td {
            position: relative;
            &:hover {
                &:before {
                    content: "";
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: -9999px;
                    bottom: -9999px;
                    background-color: rgba(255,255,255,0.2);
                    z-index: -1;
                }
            }
        }
    }
</style>